<div class="full-height layout-column recommendations-list-container">
  <div class="flex layout-column">
    <div class="full-height flex layout-column">
      <cdk-virtual-scroll-viewport [itemSize]="80" class="flex viewport" (scroll)="getNextBatch()">
        <app-recommendations-list-item *cdkVirtualFor="let recommendation of recommendations; trackBy: trackById"
                                       [recommendation]="recommendation"
                                       [showRecommendationLink]="showRecommendationLink"
                                       [direction]="direction"
                                       (updateRecommendation)="updateRecommendation.emit($event)"
                                       (goToRecommendation)="goToRecommendation.emit($event)"
                                       (markRecommendationAsRead)="markRecommendationAsRead.emit($event)"
                                       (applyRecommendation)="applyRecommendation.emit($event)"
                                       (openRoutePanelsByIds)="openRoutePanelsByIds.emit($event)"
                                       class="item">
        </app-recommendations-list-item>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>

